import React from "react";
import { Table } from "react-bootstrap";
import ToggleBar from "../../commoncomponents/toggleBar";
import { utcToDDMMYYYY, dayToHour } from "../../../utils/dateConvert";
import moment from "moment-timezone";
import { downloadCSVFile } from "../../../api/apiClient";
import ShowIButtonName from "../../commoncomponents/showIButtonName";

const openMvtlReport = (href) => {
    const browserWindow = window.opener && !window.opener.closed ? window.opener : window;
    const reportWindow = browserWindow.open(href, "_blank");

    if (reportWindow) {
        reportWindow.focus();
        return;
    }

    window.open(href, "_blank");
};

function DailySummary(props) {
    const sourceReports = props.reportDetails.dayTrips || [];
    let assetName = props.assetCustomerName;
    let timeZone = props.calendarSelectedDate ? props.calendarSelectedDate.toString().slice(25, 55) : '';
    let asset_id = props.assetId;
    let iButtonName = props.reportDetails.iButtonName;
    let ibuttonId = props.reportDetails.ibuttonId;
    let serialno = props.reportDetails.serialno;

    const isNoDataReport = (report) => {
        return Number(report.processed || 0) === 0;
    };

    const buildDailyRows = () => {
        const reportByDate = sourceReports.reduce((lookup, report) => {
            lookup[moment(report.dateTime).format("YYYY-MM-DD")] = report;
            return lookup;
        }, {});

        const startDate = moment(props.SearchDate || props.reportDetails.startDate).startOf("day");
        const endDate = moment(props.EndDate || props.reportDetails.endDate || props.SearchDate).startOf("day");

        if (!startDate.isValid() || !endDate.isValid()) {
            return sourceReports;
        }

        const rows = [];
        const currentDate = startDate.clone();

        while (currentDate.isSameOrBefore(endDate, "day")) {
            const dateKey = currentDate.format("YYYY-MM-DD");
            const report = reportByDate[dateKey];

            if (report) {
                const noData = isNoDataReport(report);

                if (!noData || !props.hideNoDataDays) {
                    rows.push({
                        ...report,
                        day: report.day || moment(report.dateTime).format("dddd"),
                        noData,
                    });
                }
            } else if (!props.hideNoDataDays) {
                rows.push({
                    noData: true,
                    day: currentDate.format("dddd"),
                    dateTime: currentDate.toISOString(),
                    asset: props.reportDetails.asset || assetName,
                    depot: props.reportDetails.depot || "",
                    timezone: props.reportDetails.timezone || "",
                    startDate: currentDate.toISOString(),
                    endDate: currentDate.toISOString(),
                    totalDays: 1,
                    daysInUse: 0,
                    utilisation: 0,
                    trips: 0,
                    virtualTrips: 0,
                    allTrips: 0,
                    engineHours: null,
                    movingEngineHours: null,
                    idlingHours: null,
                    movingEngineHoursOutside: null,
                    parked: null,
                    totalParked: null,
                    distance: 0,
                    parkedIdle: 0,
                    duress: 0,
                    powercut: 0,
                    lowBattery: 0,
                    tempA: 0,
                    tempB: 0,
                    speed: 0,
                    harshAccel: 0,
                    harshBrake: 0,
                    harshCorner: 0,
                    ohs: 0,
                    gsmLoss: 0,
                    gpsLoss: 0,
                    processed: 0,
                });
            }

            currentDate.add(1, "day");
        }

        return rows;
    };

    const reports = buildDailyRows();
    const getDailySummaryCsvRows = () => {
        return reports.map((report) => {
            if (!report.noData) {
                return {
                    ...report,
                    day: report.day || moment(report.dateTime).format("dddd"),
                };
            }

            return {
                ...report,
                day: report.day || moment(report.dateTime).format("dddd"),
                trips: 0,
                virtualTrips: 0,
                allTrips: 0,
                engineHours: 0,
                movingEngineHours: 0,
                idlingHours: 0,
                movingEngineHoursOutside: 0,
                parked: 0,
                totalParked: 0,
                distance: 0,
                parkedIdle: 0,
                duress: 0,
                powercut: 0,
                lowBattery: 0,
                tempA: 0,
                tempB: 0,
                speed: 0,
                harshAccel: 0,
                harshBrake: 0,
                harshCorner: 0,
                ohs: 0,
                gsmLoss: 0,
                gpsLoss: 0,
                processed: 0,
            };
        });
    };
    
    console.log("report detail in daily summary", props);
    const weekDayFinder = (dayProp) => {
        let dayNumber = moment(dayProp).day();
        switch (dayNumber) {
            case 1: return "Monday";
            case 2: return "Tuesday";
            case 3: return "Wednesday";
            case 4: return "Thursday";
            case 5: return "Friday";
            case 6: return "Saturday";
            case 0: return "Sunday";
            default: return null;
        }
    };

    const showTempA = props.reportDetails.assetTempA !== undefined
        ? props.reportDetails.assetTempA
        : reports.some(report => report.tempA > 0);
    const showTempB = props.reportDetails.assetTempB !== undefined
        ? props.reportDetails.assetTempB
        : reports.some(report => report.tempB > 0);

    const data = (
        <Table responsive striped>
            <thead>
                <tr className="nowwrapTH">
                    <th>Day</th>
                    <th>Date</th>
                    <th>Asset</th>
                    <th>Depot</th>
                    <th>Timezone</th>
                    <th>Trips</th>
                    <th>Virtual Trips</th>
                    <th>All Trips</th>
                    {/* <th>
                        Duration&nbsp;{" "}
                        <i
                            class="fa fa-info-circle text-primary"
                            title="First Engine ON to Last Engine OFF"
                        ></i>
                    </th>
                    <th>
                        Duration Outside Depot&nbsp;{" "}
                        <i
                            class="fa fa-info-circle text-primary"
                            title="First Departure until Last Entry or Engine OFF"
                        ></i>
                    </th> */}
                    <th>Engine Hours</th>
                    <th>
                        Moving Engine Hours&nbsp;{" "}
                        <i
                            class="fa fa-info-circle text-primary"
                            title="Engine Hours - Virtual Parked"
                        ></i>
                    </th>
                    <th>Idling Hours</th>
                    <th>
                        Moving Engine Hours Outside&nbsp;{" "}
                        <i
                        class="fa fa-info-circle text-primary"
                        title="Total moving engine hours outside depot"
                        ></i>
                    </th>
                    <th>Parked</th>
                    <th>
                        Total Parked &nbsp;
                        <i
                            class="fa fa-info-circle text-primary"
                            title="Parked + Virtual Parked"
                        ></i>
                    </th>
                    <th>Distance</th>
                    {/* <th>
                        Average Journey&nbsp;{" "}
                        <i
                            class="fa fa-info-circle text-primary"
                            title="Engine Hours / All Trips"
                        ></i>
                    </th>
                    <th>
                        Average Parked &nbsp;
                        <i
                            class="fa fa-info-circle text-primary"
                            title="Total Parked / All Trips"
                        ></i>
                    </th>
                    <th>
                        Average Distance &nbsp;
                        <i
                            class="fa fa-info-circle text-primary"
                            title="Distance / All Trips"
                        ></i>
                    </th> */}
                    <th>Parked Idle</th>
                    <th>Duress</th>
                    <th>Powercut</th>
                    <th>Low Battery</th>
                    {showTempA && <th>Temp A</th>}
                    {showTempB && <th>Temp B</th>}
                    <th>Overspeed</th>
                    <th>Harsh Accel</th>
                    <th>Harsh Brake</th>
                    <th>Harsh Corner</th>
                    <th>OH&S</th>
                    <th>GSM Loss</th>
                    <th>GPS Loss</th>
                    <th>Processed</th>
                </tr>
            </thead>
            <tbody>
                {reports.map((report, index) => {
                    const mvtlHref = `/Rpt-MVTL?assetId=${asset_id}&assetName=${report.asset}&assetDate=${moment(report.dateTime).format("YYYY-MM-DD")}`;

                    return (
                        <tr className={report.noData ? "assetSummaryNoDataRow" : report.allTrips == 0 ? "yellowBg" : ""}>
                            <td>{weekDayFinder(report.dateTime)}</td>
                            <td style={{ whiteSpace: "nowrap" }}>
                                {report.noData ? (
                                    utcToDDMMYYYY(report.dateTime)
                                ) : (
                                    <button
                                        type="button"
                                        className="reportInlineLinkButton"
                                        title="View MVTL for this date"
                                        onClick={() => openMvtlReport(mvtlHref)}
                                    >
                                        {utcToDDMMYYYY(report.dateTime)}
                                    </button>
                                )}
                                {/* <a href="#" onClick={reportMvtlog(asset_id,search_date,Timezone,user_filtering)}>{utcToDDMMYYYY(report.dateTime)}</a> */}
                            </td>

                            <td>{report.asset}
                                <br />
                                {!report.noData && (
                                    <ShowIButtonName
                                        ibuttonId={ibuttonId}
                                        serialno={serialno}
                                        iButtonName={iButtonName}
                                    />
                                )}
                            </td>
                            <td>{report.depot}</td>
                            <td>{report.timezone}</td>
                            <td>{report.trips}</td>
                            <td>{report.virtualTrips}</td>
                            <td>{report.allTrips}</td>
                            {/*<td>{utcToReportDate(report.start)}</td>*/}
                            {/*<td>{utcToReportDate(report.end)}</td>*/}
                            {/* <td>{dayToHour(report.duration)}</td>
                            <td>{dayToHour(report.durationOutsideDepot)}</td> */}
                            <td>{report.noData ? "-" : dayToHour(report.engineHours)}</td>
                            <td>{report.noData ? "-" : dayToHour(report.movingEngineHours)}</td>
                            <td>{report.noData ? "-" : dayToHour(report.idlingHours)}</td>
                            <td>{report.noData ? "-" : dayToHour(report.movingEngineHoursOutside)}</td>
                            <td>{report.parked}</td>
                            <td>{report.totalParked}</td>
                            <td>{report.distance}</td>
                            {/* <td>{report.averageJourney}</td>
                            <td>{report.averageParked}</td>
                            <td>{rounding(report.averageDistance)}</td> */}
                            <td>{report.parkedIdle}</td>
                            <td>{report.duress}</td>
                            <td>{report.powercut}</td>
                            <td>{report.lowBattery}</td>
                            {showTempA && <td>{report.tempA}</td>}
                            {showTempB && <td>{report.tempB}</td>}
                            <td>{report.speed}</td>
                            <td>{report.harshAccel}</td>
                            <td>{report.harshBrake}</td>
                            <td>{report.harshCorner}</td>
                            <td>{report.ohs}</td>
                            <td>{report.gsmLoss}%</td>
                            <td>{report.gpsLoss}%</td>
                            <td>{report.processed}</td>
                        </tr>
                    );
                })}
            </tbody>
        </Table>
    );
    const handleDownloadExcel = () => {
        // alert("clicked")
        downloadCSVFile(getDailySummaryCsvRows(), "AssetRunning_DailySummary", assetName, timeZone, asset_id);
    };
    return (
        <ToggleBar
            download={handleDownloadExcel}
            caption="Daily Summary"
            icon="fa-calendar-o"
            color="#337AB7"
            content={data}
        />
    );
}

export default DailySummary;
